import {type GameVersionDoc, GameVersionDocSchema} from "@repo/shared";

import {BaseCollectionConfig} from "../BaseCollectionConfig";
import {collectionNameV1} from "../collectionName";
import {getByIdHookFactory} from "../factories/getByIdHookFactory";
import {getByIdRealtimeSubFactory} from "../factories/getByIdRealtimeSubFactory";

export class GameVersionCollectionConfig extends BaseCollectionConfig<
  typeof GameVersionDocSchema,
  unknown
> {
  constructor() {
    super(GameVersionDocSchema);
  }

  getCollection(): [string, ...(string | undefined)[]] {
    return [collectionNameV1("version")];
  }

  parser(id: string, data: any): GameVersionDoc {
    return {
      id,
      version: data?.version ?? "0",
    };
  }
}

const key = {id: "VERSION"};
const config = new GameVersionCollectionConfig();
export const useVersion = () =>
  getByIdHookFactory(config)(key, {waitForRealtimeUpdates: true});
export const useVersionRealtimeSub = () =>
  getByIdRealtimeSubFactory(config)(key);
